import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import TurnosYAtenciones from './TurnosYAtenciones';

type Props = RouteComponentProps<{}>;

const RecepcionPrincipal: React.FunctionComponent<Props> = props => {
    return (
        <div>
            <TurnosYAtenciones />
        </div>
    );
};

export default RecepcionPrincipal;



// WEBPACK FOOTER //
// ./src/modulos/Recepcion/RecepcionPrincipal.tsx